import studentsApp from 'students';

studentsApp();
